import './style.css'
// import * as dat from 'dat.gui'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// import gsap from 'gsap'

/**
 * Base
 */
// Debug
// const gui = new dat.GUI({
//     width: 400
// })

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

// Axes
// const axesHelper = new THREE.AxesHelper(20);
// scene.add(axesHelper);

/**
 * Loaders
 */

/**
 * Textures
 */

/**
 * Materials
 */

/**
 * Rectangles
 */
const rectArray = []

const rectGeo = new THREE.BoxGeometry(5, 0.125, 0.125)
const rectMat = new THREE.MeshNormalMaterial()

for(let i = 0; i < 1000; i++){
    const rect = new THREE.Mesh(rectGeo, rectMat)
    rect.position.x = -50
    rect.position.y = (Math.random() * i) - 20
    rect.position.z = (Math.random() * i) - 50
    rect.scale.x = Math.random() * 10
    rectArray.push(rect)
    scene.add(rect)

}

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 500)
camera.position.x = 50
camera.position.y = 50   
camera.position.z = 100   
scene.add(camera)

const camera01Button = document.getElementById( 'camera01' )
camera01Button.addEventListener( 'click', function () {
    camera.position.x = 50
    camera.position.y = 50   
    camera.position.z = 100  
} )

const camera02Button = document.getElementById( 'camera02' )
camera02Button.addEventListener( 'click', function () {
    camera.position.x = 150
    camera.position.y = 0   
    camera.position.z = 5
} )

const camera03Button = document.getElementById( 'camera03' )
camera03Button.addEventListener( 'click', function () {
    camera.position.x = -50
    camera.position.y = 0   
    camera.position.z = 0
} )

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight()
scene.add(ambientLight)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.outputEncoding = THREE.sRGBEncoding
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor( 0x1a1a1a )

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Animate camera

    // Animate rectangles
    for(let i = 0; i < 1000; i++){
        if (elapsedTime < 30){
            rectArray[i].scale.x = elapsedTime * 2.5
        }
        rectArray[i].rotation.z = elapsedTime * 0.15
    }

    // Update material
 
    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()